import React, { useState } from 'react';
import { Form, Button, Col } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';

interface Props {
  maxAmount: number;
  onSubmit: (amount: string) => void;
}

const PaymentCashRefundForm = ({ maxAmount, onSubmit }: Props) => {
  const [amount, setAmount] = useState<string>('0');

  const handleAmountBlur = () => {
    // ensure amount doesn't go above max
    setAmount(String(parseFloat(amount || '0') > maxAmount ? maxAmount : amount));
  };

  return (
    <div className="d-flex flex-column flex-fill">
      <div className="flex-grow-1">
        <Form.Row>
          <Form.Group as={Col}>
            <Form.Label>Cash Refund Amount</Form.Label>
            <CurrencyInput
              allowNegativeValue={false}
              className="form-control d-inline bg-yellow-1"
              decimalsLimit={2}
              decimalScale={2}
              defaultValue={0}
              onValueChange={value => setAmount(value || '0')}
              onBlur={handleAmountBlur}
              prefix="$"
              value={amount}
            />
            <div className="input-toolbar-wrapper">
              <div className="input-toolbar">
                <Button
                  style={{ fontSize: '10px' }}
                  className="btn-xs"
                  onClick={() => setAmount(maxAmount.toFixed(2))}
                  variant="default"
                >
                  Max
                </Button>
              </div>
            </div>
            <Form.Text>Max amount: ${maxAmount.toFixed(2)}</Form.Text>
          </Form.Group>
          <Form.Group as={Col} xs="auto" className="align-self-center">
            <Button variant="warning" className="float-right" onClick={() => onSubmit(amount)}>
              Refund
            </Button>
          </Form.Group>
        </Form.Row>
      </div>
    </div>
  );
};

export default PaymentCashRefundForm;
